import { NgOptimizedImage } from "@angular/common";
import { Component, input } from "@angular/core";
import { DirectusTranslationPipe } from "../../../../../../common/pipes/directus-translation.pipe";
import { GetDirectusImagePipe } from "../../../../../../common/pipes/get-directus-image.pipe";
import { ItemsHeaderBlock } from "../../../../../api/packbo/models/items-header-block";

@Component({
    selector: "packbo-subscription-header",
    templateUrl: "./subscription-header.template.html",
    imports: [DirectusTranslationPipe, NgOptimizedImage, GetDirectusImagePipe]
})
export class SubscriptionHeaderComponent {
    public readonly headerBlock = input.required<ItemsHeaderBlock>();
}
